import AuthContext from "context/AuthContext";
import ProfileContext from "context/ProfileContext";
import React, { useContext, useState } from "react";
import { ProgressBar } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import AgreementTC from "../AgreementTC";
import BasicInfo from "./BasicInfo";
import ProfileInfo from "./ProfileInfo";
import ShopifyEmail from "./ShopifyEmail";

const ProfileForm = () => {
  let { user, setOnboardingStepCompletion } = useContext(AuthContext);
  let { uploader } = useContext(ProfileContext);
  const navigate = useNavigate();
  const [profileData, setProfileData] = useState({
    phone_number: "",
    about_me: "",
    instagram_handle: "",
    twitter_handle: "",
    tiktok_handle: "",
    facebook_handle: "",
    latitude: "",
    longitude: "",
    address: "",
    street_number: "",
    city: "",
    state: "",
    zip_code: "",
    profile_picture_id: "",
    imageFile: "",
    tag: "profile_picture",
    type: "image",
    extension: "jpg",
    store_email: user.email,
    id: user.uid,
    social_selected: false,
    otpCode: "",
    optIn: false,
    accounts: [],
    email: [user.email],
  });

  // Define steps with their hash identifiers
  const stepsConfig = [
    { hash: "shopify-email", label: "Shopify Email" },
    { hash: "basic-info", label: "Basic Info" },
    { hash: "profile-info", label: "Profile Info" },
    { hash: "agreement", label: "Agreement" },
  ];

  const [currentStep, setCurrentStep] = useState(stepsConfig[0].hash);

  const makeRequest = (formData) => {
    const response = uploader(formData);
    response
      .then(function (response) {
        if (response.status === 200) {
          // Handle NEW API response fields for non-linear onboarding
          const completedStepsArray = response?.data?.completedSteps || 
                                        response?.data?.onboarding_completed_steps ||
                                        [];
          
          if (completedStepsArray.length > 0) {
            // Import the mapping utility
            const { mapBackendStepsToFrontend } = require('utils/onboardingStepMapper.js');
            const completedStepsObject = mapBackendStepsToFrontend(completedStepsArray);
            
            // Update context and localStorage with completed steps
            setOnboardingStepCompletion(completedStepsObject);
            localStorage.setItem(
              "onboardingStepCompletion",
              JSON.stringify(completedStepsObject)
            );
          }
          
          navigate("/user/showrooms");
        }
      })
      .catch(function (err) {
        console.error("Error Occured");
      });
  };

  const handleNextStep = (newData, final = false) => {
    setProfileData((prev) => ({ ...prev, ...newData }));

    if (final) {
      makeRequest(newData);
      return;
    }
    
    // Move to next step by hash
    const currentIndex = stepsConfig.findIndex(s => s.hash === currentStep);
    if (currentIndex < stepsConfig.length - 1) {
      const nextStepHash = stepsConfig[currentIndex + 1].hash;
      setCurrentStep(nextStepHash);
    }
  };

  // Create hash-to-component mapping for label-based step tracking
  const stepComponents = {
    "shopify-email": <ShopifyEmail next={handleNextStep} data={profileData} />,
    "basic-info": <BasicInfo next={handleNextStep} data={profileData} />,
    "profile-info": <ProfileInfo next={handleNextStep} data={profileData} />,
    "agreement": <AgreementTC next={handleNextStep} data={profileData} />,
  };

  // Get current step number for progress bar
  const currentStepIndex = stepsConfig.findIndex(s => s.hash === currentStep) + 1;

  return (
    <div>
      <ProgressBar
        variant="info"
        className="step-progress-bar"
        now={currentStepIndex}
        min={0}
        max={stepsConfig.length}
        label={`${currentStepIndex}/${stepsConfig.length}`}
      />
      {stepComponents[currentStep] || <div>Invalid step</div>}
    </div>
  );
};

export default ProfileForm;
